<template>
    <div v-if="dadosCarregados">
        <b-row class="ml-1">
            <b-col cols="12" class="text-left mb-2">
                <span><b>Licitação</b></span>
                <br />
                <span class="pos-left">{{ dadosLicPropria }}</span>
            </b-col>
        </b-row>
    </div>
</template>

<script lang="ts">
import { store } from "@/store"
import { Component, Vue } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { UtilsTS } from '@/utilsts'
import contratoService from '@/services/licitacoes/contratoService'

import { ContratoLicitacaoPropria } from '@/types/licitacoes/contratos/contrato-licitacao-propria'

const CompProps = Vue.extend({
    name: 'DetalhesContratoLicitacaoPropria',
    props: {
        ctrLicPropria: {
            type: ContratoLicitacaoPropria,
            required: true
        }
    }
})

@Component
export default class DetalhesContratoLicitacaoPropria extends mixins(UtilsTS, CompProps) {
    dadosLicPropria: string;
    dadosCarregados = false

    async created() {
        try {
            store.blockScreen = true
            this.dadosLicPropria = await contratoService.buscarDadosLicitacaoPropria(this.ctrLicPropria.IdLicitacao)
            this.dadosCarregados = true
        }
        catch (e: any) {
            console.error('Erro ao montar detalhes do contrato', e)
            this.$router.push("/modulo-licitacoes/contratos/contratos-ordens-fornecimento");
            this.$toast.error(e.message || "Erro ao carregar contrato");
        } finally {
            store.blockScreen = false
        }
    }
}
</script>

<style></style>